<script>
  import _base from '../../_default/components/_base.vue'

  export default{
    name: 'Localizacao Veiculo',
    extends: _base,
    data () {
      return {}
    },
    computed: {},
    mounted () {
//      this._menuFolded(true)
    },
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
    <div class="app-content grv">
      <router-view></router-view>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?a8e0f7ce